import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';
import ScrollToHash from './components/ScrollToHash';

export default function Home() {
  return (
    <>
      <ScrollToHash />
      <Header />
      <main>
        <Hero />
        <AppSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
        <CardsSection />
        <AboutSection />
        <ContactSection />
        <FaqSection />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
        <CommentsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}